import app from './app.json';
import common from './common.json';
import page from './page.json';
const vi = {
    app,
    common,
    page
};
export default vi;
